import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Siddharth Bhandari </span>
            from <span className="purple"> Bhilwara, Rajasthan, India.</span>
            <br />I am  Pursuing B.Tech in Data Science and Artificial Intelligence Engineering from IIIT Dharwad, Karnataka.
            <br />
            <br />
              Experiences:
            <ul>
            <li className="about-activity">
              <ImPointRight /> Mitacs Globalink Research Intern at Saint Mary's University, Halifax, Canada
            </li>
            <li className="about-activity">
              <ImPointRight /> Gen AI Developer - Intern @ Bitloka Solutions Pvt. Ltd.
            </li>
            <li className="about-activity">
              <ImPointRight /> Upcoming Data Science Intern @ Ericsson
            </li>
          </ul>
          <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Basketball
            </li>
            <li className="about-activity">
              <ImPointRight /> Dancing
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
